"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_FRAME_NAVIGATION_TEXT = exports.APP_BASE_PORTAL_CONSENT_TEXT = exports.APP_BASE_PORTAL_SIGN_IN_TEXT = void 0;
exports.appBasePlatformPageLanguage = appBasePlatformPageLanguage;
const brand_1 = require("@streamlain/brand");
/** German for a German locale, else English. */
function appBasePlatformPageLanguage(locale) {
    return locale.toLowerCase().startsWith('de') ? 'de' : 'en';
}
/**
 * The words of the portal sign-in page, by language. `{provider}` stands for
 * the name of a sign-in provider. The messages are keyed by the error the
 * sign-in hands back in `?error=`. `gate` and `gateLink` are the page that
 * sends a visitor of a portal page to the sign-in.
 */
exports.APP_BASE_PORTAL_SIGN_IN_TEXT = {
    de: {
        title: 'Portal-Anmeldung',
        intro: `Melde dich mit einem Passkey oder deinem Anbieter an. Mitglieder des Teams melden sich mit ${brand_1.BRAND_DISPLAY_NAME} an.`,
        staff: `Mit ${brand_1.BRAND_DISPLAY_NAME} anmelden`,
        passkey: 'Mit Passkey anmelden',
        name: 'Name',
        register: 'Passkey erstellen',
        provider: 'Mit {provider} anmelden',
        confirmPasskey: 'Bitte bestätige deinen Passkey.',
        cancelled: 'Anmeldung abgebrochen.',
        failed: 'Anmeldung fehlgeschlagen.',
        requestFailed: 'Anmeldung nicht möglich. Bitte erneut versuchen.',
        full: 'Dieses Portal nimmt gerade keine neuen Nutzer auf. Bitte wende dich an den Betreiber.',
        denied: `Die Anmeldung mit ${brand_1.BRAND_DISPLAY_NAME} wurde abgebrochen.`,
        noAccess: `Kein Zugang: Dein ${brand_1.BRAND_DISPLAY_NAME}-Konto ist für dieses Portal weder Mitglied noch eingeladen.`,
        gate: 'Melde dich mit einem Passkey oder deinem Anbieter an.',
        gateLink: 'Zum Portal-Login',
    },
    en: {
        title: 'Portal sign-in',
        intro: `Sign in with a passkey or your provider. Team members sign in with ${brand_1.BRAND_DISPLAY_NAME}.`,
        staff: `Sign in with ${brand_1.BRAND_DISPLAY_NAME}`,
        passkey: 'Sign in with passkey',
        name: 'Name',
        register: 'Create passkey',
        provider: 'Sign in with {provider}',
        confirmPasskey: 'Please confirm your passkey.',
        cancelled: 'Sign-in cancelled.',
        failed: 'Sign-in failed.',
        requestFailed: 'Sign-in not possible. Please try again.',
        full: 'This portal is not taking new users right now. Please contact the operator.',
        denied: `Signing in with ${brand_1.BRAND_DISPLAY_NAME} was cancelled.`,
        noAccess: `No access: your ${brand_1.BRAND_DISPLAY_NAME} account is neither a member of this portal nor invited to it.`,
        gate: 'Sign in with a passkey or your provider.',
        gateLink: 'Go to the portal sign-in',
    },
};
/**
 * The words of the consent page on the platform before a portal receives the
 * name and email of a team member, by language. `{portal}` stands for the name
 * of the portal.
 */
exports.APP_BASE_PORTAL_CONSENT_TEXT = {
    de: {
        title: 'Anmelden bei {portal}',
        body: `{portal} erhält deinen Namen und deine E-Mail-Adresse. Weitere Daten deines ${brand_1.BRAND_DISPLAY_NAME}-Kontos und deine anderen Workspaces bleiben verborgen.`,
        approve: 'Zustimmen und anmelden',
        cancel: 'Abbrechen',
    },
    en: {
        title: 'Sign in to {portal}',
        body: `{portal} receives your name and email address. Other data of your ${brand_1.BRAND_DISPLAY_NAME} account and your other workspaces stay hidden.`,
        approve: 'Agree and sign in',
        cancel: 'Cancel',
    },
};
/** Platform words of the adaptive App Container navigation. */
exports.APP_BASE_FRAME_NAVIGATION_TEXT = {
    de: {
        more: 'Mehr',
        label: 'Hauptnavigation',
        actions: 'Aktionen',
        side: 'Navigation ein- oder ausblenden',
    },
    en: {
        more: 'More',
        label: 'Main navigation',
        actions: 'Actions',
        side: 'Show or hide navigation',
    },
};
